import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import './AlumnoForm.css';
import './MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class AddAlumnos extends Component {
  static displayName = AddAlumnos.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dni: '',
      name: '',
      errorMessage: '',
      successMessage: '',
      redirect: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDNIChangeInput = this.handleDNIChangeInput.bind(this);
    this.handleNameChangeInput = this.handleNameChangeInput.bind(this);
  }

  componentDidMount() {
    constantClass.canAccess('WWAlumnos');
  }

  clearFeedback() {
    if (this.state.errorMessage || this.state.successMessage) {
      this.setState({ errorMessage: '', successMessage: '' });
    }
  }

  handleDNIChangeInput(e) {
    this.clearFeedback();
    this.setState({ dni: e.target.value });
  }

  handleNameChangeInput(e) {
    this.clearFeedback();
    this.setState({ name: e.target.value });
  }

  isFormValid() {
    return this.state.dni.trim().length > 0 && this.state.name.trim().length > 0;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (isSubmitInProgress(this.state.loading)) {
      return;
    }
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Los campos Documento y Nombre son obligatorios.' });
      return;
    }
    this.saveStudent();
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) {
      return;
    }

    const dni = this.state.dni.trim();
    const name = this.state.name.trim();

    this.setState({ loading: true, errorMessage: '', successMessage: '' });

    const { data } = await constantClass.apiFetch('api/Students/', {
      method: 'POST',
      body: JSON.stringify({ AlumnoNombre: name, AlumnoDni: dni }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo guardar el alumno. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-alumnos" />;
    }

    const { loading, dni, name, errorMessage } = this.state;
    const isBusy = loading;

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-alumnos">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">Nuevo Alumno</h1>
        <p className="md-form-page__subtitle">
          Complete el documento y el nombre completo para registrar un nuevo alumno.
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {loading ? (
                <span className="md-form-page__loading">Guardando alumno, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="alumno-dni">
                Documento de Identidad
              </label>
              <input
                id="alumno-dni"
                className="md-form-page__input"
                type="text"
                name="dni"
                autoComplete="off"
                placeholder="Ingrese DNI"
                value={dni}
                onChange={this.handleDNIChangeInput}
                disabled={isBusy}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="alumno-nombre">
                Nombre Completo
              </label>
              <input
                id="alumno-nombre"
                className="md-form-page__input"
                type="text"
                name="name"
                autoComplete="off"
                placeholder="Ingrese nombre y apellido"
                value={name}
                onChange={this.handleNameChangeInput}
                disabled={isBusy}
                required
              />
            </div>

            <div className="md-form-page__actions">
              <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                Confirmar
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
